import React from 'react';
import Button from 'components/Button/Button';
import { t } from '../../helpers/componentHelper';
import { useNavigate } from 'react-router-dom';

import './Pricing.scss';

type PricingComponentProps = {
  userGroup: string;
};

// top level Pricing page component, isolated from routing logic
function Pricing({ userGroup }: PricingComponentProps) {
  const navigate = useNavigate();

  return (
    <div className="pricing">
      <div className={'pricing__header'}>
        <div>{`${t('pages.pricing.headerText')}`}</div>
        <div className={'pricing__header--subtext'}>{`${t('pages.pricing.headerSubtext')}`}</div>
      </div>
      <div className="pricing__info">
        <div className="pricing__info--grid">
          <div className="pricing__info--grid-item">
            <div className="pricing__info--grid-item-header">{`${t(
              'pages.pricing.elitePlan',
            )}`}</div>
            <div className="pricing__info--grid-item-price">{`${t(
              'pages.pricing.elitePlanPrice',
            )}`}</div>
            <ul className="pricing__info--grid-item-features">
              <b>
                <li>{`${t('pages.pricing.elitePlanFeature1')}`}</li>
              </b>
              <li>
                {`${t('pages.pricing.elitePlanFeature2')} `}
                <b>NEEDS</b>
                {` ${t('pages.pricing.elitePlanFeature2Pt2')}`}
              </li>
              <li>
                {`${t('pages.pricing.elitePlanFeature3')} `}
                <b>all of our picks as soon as we do</b>
                {`${t('pages.pricing.elitePlanFeature3Pt2')}`}
              </li>
              <li>{`${t('pages.pricing.elitePlanFeature4')}`}</li>
              <li>{`${t('pages.pricing.elitePlanFeature5')}`}</li>
              <li>{`${t('pages.pricing.elitePlanFeature6')}`}</li>
            </ul>
            <div className="pricing__info--grid-item-cta">
              {userGroup.toLocaleLowerCase().includes('elite') ||
              userGroup.toLocaleLowerCase().includes('ad') ? (
                <Button
                  text={`${t('pages.pricing.currentPlan')}`}
                  variant="default"
                  active={false}
                  size="large"
                />
              ) : (
                <Button
                  text={`${t('pages.pricing.contactUs')}`}
                  variant="default"
                  active={false}
                  size="large"
                  onClick={() => navigate(`/contact`)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Pricing;
